export function getFullName(user) {
  user = user || {};
  if (user.firstName || user.lastName)
    return `${user.firstName || ""} ${user.lastName || ""}`.trim();
  else if (user.fullName) return user.fullName;
  else if (user.username) return user.username;
}
